import { defineStore } from "pinia";

export const useLanguageStore = defineStore({
  id: "language",
  state: () => {
    return {
      selected: "ja",
    };
  },
  actions: {
    setLanguage(language) {
      this.selected = language;
    },
  },
  persist: true,
});
